<template>
  <el-dropdown
    ref="dropdown"
    v-el-dropdown-active="id"
    :disabled="disabled"
    :class="[b(), { 'is-disabled': disabled }]"
    trigger="click"
    size="default"
    @command="commandHandler"
    @visible-change="handleVisibleChange"
  >
    <div
      :class="['cursor-pointer', b('trigger'), { 'is-disabled': disabled }]"
      @click="$emit('click')"
    >
      <span :class="[b('icon', {visible: visible})]">
        <em
          class="zkicon iconyouxianji"
          :style="{ color: priorityColor }"
        />
      </span>
    </div>
    <el-dropdown-menu
      slot="dropdown"
      :modal="modal"
      :modal-with-dialog="modalWithDialog"
    >
      <template v-if="visible">
        <div :class="b('clear')">
          <span
            v-if="canClear && id"
            :class="b('name')"
            @click="clear"
          >{{ $t('button.clear') }}</span>
        </div>
        <el-dropdown-item
          v-for="p in prioritys"
          :key="p.id"
          :command="p.id"
        >
          <em
            class="zkicon iconyouxianji"
            :style="{ color: p.color }"
          />
          <span :class="b('name')">{{ p.name }}</span>
        </el-dropdown-item>
      </template>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import bem from '@zk/bem';
export default {
  name: 'PriorityDropdown',
  mixins: [bem],
  bemNS: 'zk',
  props: {
    prioritys: {
      type: Array,
      default: () => []
    },
    value: {
      type: Number,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    modal: {
      type: Boolean,
      default: true
    },
    modalWithDialog: {
      type: [String, HTMLElement, Function, Boolean],
      default: null
    },
    canClear: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      id: this.value,
      visible: false
    };
  },
  computed: {
    current() {
      if (!this.id) {
        return this.prioritys.find(item => !item.id);
      }
      return this.prioritys.find(item => item.id === this.id);
    },
    priorityColor() {
      return this.current?.color || '#d7d7d7';
    }
  },
  watch: {
    value(value) {
      this.id = value;
    },
    id(value) {
      this.$emit('input', value);
    }
  },
  methods: {
    commandHandler(command) {
      if (command === this.id) {
        return;
      }
      this.id = command;
      this.$emit('change', this.id);
    },
    handleVisibleChange(visible){
      this.visible = visible;
      this.$emit('visible-change', visible);
    },
    clear(){
      // this.id = null;
      this.$emit('change', null);
      // this.$emit('input', null);
      this.$refs.dropdown?.hide();
    }
  }
};
</script>
<style lang="scss">
@import "~@zk/theme/lib/mixins";
@import "~@zk/theme/lib/scss-index.scss";

// $background: #F6F9FF;
$background: var(--gray-transparent-hover);
@include b(priority-dropdown) {
  @include e(trigger) {
    outline: none;
    &:not(.is-disabled):hover {
      @include iconColor($--color-primary);
      color: $--color-primary;
    }
  }
  @include e(icon){
    padding: 1px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content:center;
    &:hover{
     background: $background;
    }
    @include m(visible){
      background: $background;
    }
  }
  @include e(name){
    margin-left:10px;
  }
  @include e(clear){
    color: var(--primary-color);
    line-height: 36px;
    > span {
      cursor: pointer;
    }
  }
}
</style>
